import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import Swal from "sweetalert2";
Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    users: null,
    token: null,
    idTrabajador: null,
    trabacceso: null, // Añadimos el valor de trabacceso en el estado
  },
  getters: {
    Users(state) {
      return state.users;
    },

    Tokens(state) {
      return state.token;
    },

    IdTrabajador(state) {
      return state.idTrabajador;
    },
    Trabacceso(state) {
      return state.trabacceso; // Getter para acceder a trabacceso
    },
  },
  mutations: {
    llenarUser(state, data) {
      state.users = data;
    },

    llenarToken(state, data) {
      state.token = data;
    },

    llenarIdTrabajador(state, data) {
      state.idTrabajador = data;
    },

    llenarTrabacceso(state, data) {
      state.trabacceso = data; // Guarda el valor de trabacceso en Vuex
    },
  },

  actions: {
    async login({ commit }, user) {
      await axios
        .post("Autentication/ValidarUsers", user)
        .then((datos) => {
          console.log(datos.data);
          if (datos.data.token) {
            this.spinner = true;
            this.boton = false;

            const authToken = datos.data.token;
            const authUser = datos.data.userId;
            const authIdTrabajador = datos.data.idTrabajdor;
            const idSolxPostulante = datos.data.idSolxPostulante;
            const idPerfil = datos.data.idPerfil;
            const plataformas = datos.data.catPlataforma;
            const trabacceso = datos.data.trabacceso;
            const usuEstado = datos.data.usuEstado;
            const usuCodigo = datos.data.usuCodigo;
            const usuAuxiliar = datos.data.usuAuxiliar;
            const fechaNacimiento = datos.data.usuFecNacimiento.slice(0, 10);
            const contrasena = datos.data.usuContrasena;
            const EstadoSoporte = datos.data.estadoSoporte
            // const tiempoExpirado = datos.data.config.validTo
            localStorage.setItem("access_token", authToken);
            localStorage.setItem("userId", authUser);
            localStorage.setItem("idTrabajdor", authIdTrabajador);
            localStorage.setItem("idSolxPostulante", idSolxPostulante);
            localStorage.setItem("idPerfil", idPerfil);
            localStorage.setItem("plataformasDisponibles", plataformas);
            localStorage.setItem("trabacceso", trabacceso);
            localStorage.setItem('usuEstado',usuEstado);
            localStorage.setItem('usuCodigo', usuCodigo);
            localStorage.setItem('usuAuxiliar', usuAuxiliar);
            localStorage.setItem('datos', JSON.stringify(datos))
            localStorage.setItem('firma', datos.data.firma)
            localStorage.setItem('fechaNacimiento', fechaNacimiento)
            localStorage.setItem('usuContrasena', contrasena)
            localStorage.setItem('EstadoSoporte', EstadoSoporte)
            // commit("llenarTrabacceso", trabacceso); // Guardamos trabac
            // ceso en Vuex
            commit("llenarUser", datos.data.userId);
            commit("llenarToken", datos.data.token);
            commit("llenarIdTrabajador", datos.data.idTrabajdor);
            

            // localStorage.setItem("tiempoCaducado", tiempoExpirado.slice(11,19))
            window.location.reload(true);
          }
        })
        .catch((error) => {
          console.log(error.response.data);
          if (error.response.data) {
            Swal.fire({
              icon: "error",
              title: `${error.response.data}`,
              text: "",
              footer: "",
            });
          }
        });
    },

    initializeFromLocalStorage({ commit }) {
      const trabacceso = localStorage.getItem('trabacceso');
      if (trabacceso) {
        commit('llenarTrabacceso', trabacceso); // Aquí recuperas el valor de trabacceso desde localStorage y lo guardas en Vuex
      }
    },
  },
  modules: {},
};
